import React from 'react'
import { toast } from 'react-toastify'
import callable from '../utils/callable'
import ConfirmNotification from '../components/ConfirmNotification'

const useConfirmationNotification = (onConfirm, conditionMet = false) => {
  let toastId

  const dismiss = () => {
    toast.dismiss(toastId)
    toastId = null
  }

  const notification = (
    <ConfirmNotification
      label={'Warning'}
      message={'You are about to alter a split order, which will force a recalculation of the total. Do you wish to continue?'}
      onCancel={dismiss}
      onConfirm={() => {
        callable(onConfirm)
        dismiss()
      }}
      buttonOneText={'Cancel'}
      buttonTwoText={'Proceed'}
    />
  )

  if (conditionMet) {
    toastId = toast(notification, { autoClose: false, closeOnClick: false })
  } else {
    callable(onConfirm)
  }

}

export default useConfirmationNotification
